import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FieldWrap } from "@/components/Field";
import { useApp } from "@/context/AppContext";
import { api, errMsg } from "@/lib/api";
import { LoginHistory } from "@/components/admin/LoginHistory";

export function MyInfoDialog({ open, onClose, onSaved }) {
  const { user, refreshMe, isFullAdmin } = useApp();
  const [v, setV] = useState({ name: "", email: "", title: "", username: "", reply_email: "" });
  useEffect(() => { if (open && user) setV({ name: user.name || "", email: user.email || "", title: user.title || "", username: user.username || "", reply_email: user.reply_email || "" }); }, [open, user]);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/auth/me", { ...v, username: v.username || "" }); await refreshMe(); toast.success("Your info is saved"); onSaved?.(); onClose(); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="my-info-dialog">
        <DialogHeader><DialogTitle>My info</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <FieldWrap label="Full name" required><Input className="h-11" value={v.name} onChange={set("name")} required data-testid="my-info-name" /></FieldWrap>
          <FieldWrap label="Title"><Input className="h-11" value={v.title} onChange={set("title")} maxLength={60} data-testid="my-info-title" /></FieldWrap>
          <FieldWrap label="Email" required><Input type="email" className="h-11" value={v.email} onChange={set("email")} required data-testid="my-info-email" /></FieldWrap>
          <FieldWrap label="Username (optional)"><Input className="h-11" value={v.username} onChange={set("username")} autoComplete="off" data-testid="my-info-username" /></FieldWrap>
          <FieldWrap label="Receipt reply email (optional)" sub="Receipt emails you send show your name, and replies come to this address. Leave empty to use the usual MWJK address.">
            <Input type="email" className="h-11" value={v.reply_email} onChange={set("reply_email")} placeholder="you@example.com" data-testid="my-info-reply-email" />
          </FieldWrap>
          <p className="text-xs text-slate-500">To change your password, use Change password in the menu at the top right.</p>
          {open && user && isFullAdmin && <LoginHistory uid={user.id} createdAt={user.created_at} />}
          <Button type="submit" className="w-full" data-testid="my-info-save">Save</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
